import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { isEmpty } from 'lodash-es'

// Libs
import { handleGtmClickCustomService, handleGtmClickNavigation, handleGtmClickAds } from '@/methods/handleGtmEvent'
import { useAppSelector } from '@/redux/hooks'
import useI18n from '@/hooks/useI18n'

// Components
import MenuItem from '../../shared/MenuItem'
import SocialMediaList from '../SocialMediaList'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'
import { REGION } from '@/constants/region'
import { envConfigs } from '@/constants/config'
import { ROUTE_PATH } from '@/constants/routePath'

// types
import { GTM_LOCATION, GtmNavigationParams, GtmClickAdsClickText } from '@/constants/gtmEvent'

// Styles

interface SecondaryMenuProps {
  handleMenuClose: () => void
}

const SecondaryMenu = ({ handleMenuClose }: SecondaryMenuProps) => {
  const { t } = useTranslation('')
  const router = useRouter()
  const currentLocale = router.locale
  const commonData = useAppSelector((state) => state.common)
  const { isOverseaUser } = useI18n()
  const dittoCountryCode: string =
    !isEmpty(commonData) && !isEmpty(commonData?.locationData) && !isEmpty(commonData?.locationData?._dittoCountryCode)
      ? commonData?.locationData?._dittoCountryCode || REGION.TW
      : REGION.TW
  const secondaryMenuRowData = [
    {
      text: t('Header_Secondary_Menu_Become_Merchant'),
      allowedRegion: [REGION.TW],
      excludeRegion: [],
      url: EXTERNAL_LINK.BECOME_MERCHANT,
      handleClick: () => {
        handleGtmClickAds({ clickText: t(GtmClickAdsClickText.RECRUITMENT_MERCHANT, { lng: 'zh-tw' }) })
      },
    },
    {
      text: t('Header_Secondary_Menu_Become_KOL'),
      allowedRegion: [REGION.TW],
      excludeRegion: [],
      url: EXTERNAL_LINK.BECOME_KOL,
      handleClick: () => {
        handleGtmClickAds({ clickText: t(GtmClickAdsClickText.RECRUITMENT_KOL, { lng: 'zh-tw' }) })
      },
    },
    {
      text: t('Header_Secondary_Menu_FAQ'),
      allowedRegion: [REGION.TW],
      excludeRegion: [],
      url: EXTERNAL_LINK.FAQ,
      handleClick: () => {
        handleGtmClickNavigation({ clickText: t(GtmNavigationParams.FAQ, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
    {
      text: t('Header_Secondary_Menu_Customer_Service_Center'),
      allowedRegion: [],
      excludeRegion: [],
      url: isOverseaUser ? EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER_HK : EXTERNAL_LINK.CUSTOMER_SERVICE_CENTER,
      handleClick: () => {
        handleGtmClickCustomService({ location: GTM_LOCATION.NAVIGATION })
      },
    },
    {
      text: t('Header_Secondary_Menu_Terms_Of_Service'),
      allowedRegion: [REGION.TW],
      excludeRegion: [],
      url: isOverseaUser ? EXTERNAL_LINK.TERMS_OF_SERVICE_HK : EXTERNAL_LINK.TERMS_OF_SERVICE,
      handleClick: () => {
        handleGtmClickNavigation({ clickText: t(GtmNavigationParams.TERMS_OF_SERVICE, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
    {
      text: t('Common_Header_Menu_Legal_Disclaimer'),
      allowedRegion: [],
      excludeRegion: [REGION.TW],
      url: `${envConfigs.domainUrl}/${currentLocale}${ROUTE_PATH.LEGAL_DISCLAIMER}`,
      handleClick: () => {
        // handleGtmClickNavigation({ clickText: t(GtmNavigationParams.TERMS_OF_SERVICE, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
    {
      text: t('Common_Header_Menu_Privacy_Policy'),
      allowedRegion: [],
      excludeRegion: [REGION.TW],
      url: `${envConfigs.domainUrl}/${currentLocale}${ROUTE_PATH.PRIVACY_POLICY}`,
      handleClick: () => {
        // handleGtmClickNavigation({ clickText: t(GtmNavigationParams.TERMS_OF_SERVICE, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
    {
      text: t('Common_Header_Menu_User_Terms'),
      allowedRegion: [],
      excludeRegion: [REGION.TW],
      url: `${envConfigs.domainUrl}/${currentLocale}${ROUTE_PATH.USER_TERMS}`,
      handleClick: () => {
        // handleGtmClickNavigation({ clickText: t(GtmNavigationParams.TERMS_OF_SERVICE, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
    {
      text: t('Header_Secondary_Menu_Return_Policy'),
      allowedRegion: [REGION.TW],
      excludeRegion: [],
      url: EXTERNAL_LINK.RETURN_POLICY,
      handleClick: () => {
        handleGtmClickNavigation({ clickText: t(GtmNavigationParams.RETURN_POLICY, { lng: 'zh-tw' }) as GtmNavigationParams })
      },
    },
  ]
  // 支援排除指定名單的項目
  const secondaryMenuData = secondaryMenuRowData.filter((menuItem) => {
    if (Array.isArray(menuItem.excludeRegion) && (menuItem.excludeRegion as string[]).includes(dittoCountryCode as string)) {
      return false
    }

    return menuItem.allowedRegion.length === 0 || (menuItem.allowedRegion as string[]).includes(dittoCountryCode as string)
  })

  return (
    <>
      {secondaryMenuData.map((item, index) => (
        <MenuItem
          key={index}
          text={item.text}
          url={item.url}
          handleClick={() => {
            item.handleClick()
            handleMenuClose()
          }}
        />
      ))}
      <SocialMediaList handleDropdownMenuClose={handleMenuClose} />
    </>
  )
}
export default SecondaryMenu
